var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 138,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#menuUp_svg__filter0_d_1830_72625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 24.667a4 4 0 012.462-3.693L44 12v98l-21.538-8.974A4 4 0 0120 97.333V24.667z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24.667a3.5 3.5 0 012.154-3.231L43.5 12.75v96.5l-20.846-8.686a3.5 3.5 0 01-2.154-3.23V24.666z",
    stroke: "#F0F0F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.515 60.23l5.578-4.812c.208-.178.512-.017.512.271v9.621c0 .288-.305.45-.512.27l-5.579-4.81a.367.367 0 01.001-.54z",
    fill: "#29C1B9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "menuUp_svg__filter0_d_1830_72625",
    x: 0,
    y: 0,
    width: 64,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.898039 0 0 0 0 0.898039 0 0 0 0 0.898039 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1830_72625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1830_72625",
    result: "shape"
  })))));
}
export default SvgMenuUp;